// Money on the booking pages whose v1 version showed whole amounts without
// pence (@obby/lib's Number__Currency: "£50", "£12.50"): the manage page's
// receipt and payment account, the cancel page's refund, and the bundle
// page. The other amounts use the package's formatCurrency
// (~/widgets/lib/utils), which always shows pence. Pure.

/** Pence as money: "£50" for whole amounts, "£12.50" otherwise, in the
 * given currency (GBP when it isn't one Intl knows). */
export function formatMoney(pence: number | undefined | null, currency = "GBP"): string {
  if (typeof pence !== "number" || Number.isNaN(pence)) return "--.--";
  const digits = pence % 100 === 0 ? 0 : 2;
  const format = (code: string) =>
    new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: code,
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    }).format(pence / 100);
  try {
    return format((currency || "GBP").toUpperCase());
  } catch {
    return format("GBP");
  }
}
